import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  showArrow?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  showArrow = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#7B9E6B] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#7B9E6B] text-white hover:bg-[#6A8A5C] shadow-md hover:shadow-lg text-lg py-4 px-8',
    secondary: 'bg-[#FDFBF7] text-[#2D2A26] border-2 border-[#2D2A26] hover:bg-[#F0EEE9] text-base py-3 px-6'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={combinedClassName} data-id="element-249">
        <span data-id="element-250">{children}</span>
        {showArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-251" />}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-252">
      <span data-id="element-253">{children}</span>
      {showArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-254" />}
    </button>;
}